// extracted by mini-css-extract-plugin
module.exports = {"badge":"postBadge_badge__Ebck7","featuredBadge":"postBadge_featuredBadge__C5fO7","categoryBadge":"postBadge_categoryBadge__JuMin"};